import { Classes, FormGroup, Position } from "@blueprintjs/core"
import { DateRangeInput, DateRangeInputProps } from "@blueprintjs/datetime"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import customParseFormat from "dayjs/plugin/customParseFormat"
import React from "react"
import {
  FormControllerProps,
  withFormController,
} from "../Molecules/FormController"
import classNames from "utils/classNames"
import { CustomFormGroupProps } from "./CustomFormGroup"
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)

export interface CustomDateRangeProps
  extends Omit<DateRangeInputProps, "onChange" | "value">,
    FormControllerProps,
    CustomFormGroupProps {
  path: string
  valueAs?: string
  fill?: boolean
  /**
   * Determines whether the positioning of the element should be fixed or not
   * Useful when being rendered inside a modal or sometimes, a drawer!
   * @default false
   */
  fixed?: boolean
  value?: [string | Date, string | Date] | undefined
  popoverClassName?: string
}
const CustomDateRange = ({
  popoverClassName,
  required,
  labelInfo,
  label,
  onChange,
  path,
  valueAs,
  className,
  inline,
  helperText,
  value,
  big,
  fill,
  minDate,
  maxDate,
  shortcuts,
  disabled,
  fixed,
  timePickerProps,
}: CustomDateRangeProps) => {
  function handleChange(sr: Array<any>) {
    if (!sr) onChange(path, [])
    const dates = sr.map(d => dayjs(d).format(valueAs))
    onChange(path, dates)
  }

  function parseDate(date: any) {
    // Parse the date as a moment object and then return
    return date && dayjs(date, valueAs)
      ? dayjs(date, valueAs).toDate()
      : undefined
  }
  const values: any = value
    ? [parseDate(value?.[0]), parseDate(value?.[1])]
    : [undefined, undefined]

  return (
    <FormGroup
      disabled={disabled}
      inline={inline}
      className={classNames(
        "vt-custom-dateinput",
        { "vt-input-big": big, "vt-input-stretch": fill },
        className
      )}
      label={label}
      helperText={helperText}
      labelInfo={
        required ? <span className={Classes.INTENT_DANGER}>*</span> : labelInfo
      }
    >
      <DateRangeInput
        timePickerProps={timePickerProps}
        disabled={disabled}
        endInputProps={{
          fill,
          placeholder: "To",
        }}
        startInputProps={{
          fill,
          placeholder: "From",
        }}
        className={classNames("vt-custom-date-range-picker", {
          "vt-custom-date-range-picker-fixed": fixed,
        })}
        popoverProps={{
          minimal: true,
          position: Position.BOTTOM_LEFT,
          popoverClassName: classNames(
            "vt-custom-date-range-popover",
            popoverClassName
          ),
        }}
        allowSingleDayRange={true}
        formatDate={e => dayjs(e).format("Do MMM YYYY")}
        onChange={handleChange}
        parseDate={str => new Date(str)}
        value={values}
        shortcuts={shortcuts}
        minDate={minDate}
        maxDate={maxDate}
      />
    </FormGroup>
  )
}

CustomDateRange.defaultProps = {
  fixed: false,
  valueAs: "YYYY-MM-DD",
  big: true,
  shortcuts: false,
}
export default withFormController(CustomDateRange)
